(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedDosageUnitDeleteController',MedDosageUnitDeleteController);

    MedDosageUnitDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedDosageUnit'];

    function MedDosageUnitDeleteController($uibModalInstance, entity, MedDosageUnit) {
        var vm = this;

        vm.medDosageUnit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedDosageUnit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
